import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';


@Component({
  selector: 'app-redmeption-report',
  templateUrl: './redmeption-report.component.html',
  styleUrls: ['./redmeption-report.component.scss']
})
export class RedmeptionReportComponent implements OnInit {
  date ;
  selectedDate : any = ""
   constructor(
     private apiService : ApiService,
     private apiConfig : ApiConfiguration,
     private exportExcelService : ExportExcelService
   ) { 
     let currentDate = new Date()
     this.date = moment(currentDate).format("YYYY-MM-DD")
     this.selectedDate = this.date
   }
 
   ngOnInit() {
   }
 
   
 
   filterListOfRecords(){
     this.apiService.get(this.apiConfig.liveReport + `?program_id=1&date=${this.date}&report_id=1`).subscribe((res : any)=>{
       console.log(res);
       this.downloadExcel(res.data.report_data)
     })
   }
 
   downloadExcel(data){
     let sheetName = "sheet1";
     let filename = "Redemption_report_";
     let excelData = data;
     let excelArray = [
      { header: 'User Id', key: 'user_id'},
      { header: 'CSM Name', key: 'customer_name'},
      { header: 'Csm Mobile Number',key: 'mobile_no'},
      { header: 'Currently Mapped Outlet/Osmosys Code', key: 'outlet_code'},
      { header: 'Ordered Date', key: 'redemption_date'},
      { header: 'Order ID', key: 'order_id' },
      { header: 'Order Reference Number', key: 'order_refno'},
      { header: 'Product/Voucher Name', key: 'prod_name'},
      { header: 'Value', key: 'denominations'},
      { header: 'Response QC Order ID', key: 'response_orderid'},
      { header: 'Points Redeemed',key: 'redeem_points'},
      { header: 'Processed Date',key: 'processed_date'},
      { header: 'Current Status',key: 'status'},
      { header: 'Failure Reason', key: 'order_error_status'},
      { header: 'TDS (%)',key: 'tds_percentage'},
      { header: 'TDS Points', key: 'tds_points'}
     ]

     this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
   }
 
 }
 